/**
 * Configuration for jobs in this app.
 */
/* tslint:disable */

const allowedForcedRegistrationDestination = {
  Register: 'register',
  Login: 'login',
};

module.exports = {
  public: {
    JOBS_PAGE: '/jobs',
    JOBS_LISTING_NUMBER: 10,
    JOBS_LISTING_SEO_TITLE: false,
    JOB_DETAIL_FIELDS: {
      job_info: {
        key: 'job_info',
        name: 'Job information',
        description: `Provide information about the job you are creating.`,
        top_info_popover: '',
        fields: {
          title: 'title',
          field_job_link: 'linkUrl',
          field_job_file: 'file',
          field_job_description: 'description',
          field_job_availability_period: 'availabilityPeriod',
          field_job_video_link: 'videoUrl',
        },
      },
      company_info: {
        key: 'company_info',
        name: 'Company information',
        description: `Provide information about your company.`,
        top_info_popover: '',
        fields: {
          field_job_organization: 'organization',
          field_organization_assignment: 'organizationAssignment',
          field_job_logo: 'logo',
        },
      },
      job_location: {
        key: 'job_location',
        name: 'Job location',
        description: `Provide information about the location for the job.`,
        top_info_popover: '',
        fields: {
          field_job_location: 'address',
          field_remote_option: 'remoteOptions',
        },
      },
      job_categorization: {
        key: 'job_categorization',
        name: 'Job categorization',
        description: `Provide here more detailed information about the job, this information will help categorize the job
        properly and make it more accessible to applicants when searching jobs.`,
        top_info_popover: '',
        fields: {
          field_job_employment_type: 'employmentType',
          field_job_occupational_field: 'occupationalField',
          field_job_fields_of_study: 'fieldsOfStudy',
          field_job_degree_level: 'degreeLevel',
          field_job_experience: 'yearsOfExperience',
          field_job_salary_range: 'salaryRange',
          field_job_salary_range_free_inpu: {
            name: 'salaryRangeFree',
            fields: {
              min_salary: 'minSalary',
              max_salary: 'maxSalary',
              currency_code: 'currencyCode',
              salary_unit: 'salaryUnit',
            },
          },
          field_job_languages: 'languages',
          field_job_languages_free: 'languagesFree',
          field_job_skills: 'skills',
          field_job_skills_free: 'skillsFree',
        },
      },
      job_schedule: {
        key: 'job_schedule',
        name: 'Job schedule',
        description: `Provide information about the job publication date and how long the job will be online.`,
        top_info_popover: '',
        fields: {
          field_job_publishing_date: 'published',
          field_job_expiration_date: 'expiration',
          field_job_duration: 'duration',
        },
      },
      job_application_options: {
        key: 'job_application_options',
        name: 'Application options',
        description: `Specific how candidates can apply to this job.`,
        top_info_popover: '',
        fields: {
          field_job_application_workflow: 'applicationWorkflow',
          field_job_application_email: 'applicationEmails',
          field_job_application_link: 'applicationLink',
          field_job_application_require_cv: 'applicationRequireCv',
          field_job_app_require_cover: 'applicationRequireCoverLetter',
          field_job_app_require_questions:
            'applicationRequireQualifyingQuestions',
          field_job_app_questions: 'applicationQualifyingQuestions',
        },
      },
    },
    JOB_TEASER: {
      HIDE_ICONS_MOBILE: true,
      LOGO_WIDTH: 50, // Should not go over the image style (112px)
    },
    JOB_EDIT_HIDDEN_FIELDS: ['title'],
    FACETS: {
      remoteOptions: {
        title: 'Remote options',
        fieldName: 'field_remote_option',
        vid: 'remote_options',
        multiple: true,
        operator: 'OR',
      },
      employmentType: {
        title: 'Employment type',
        fieldName: 'field_job_employment_type',
        vid: 'employment_type',
        multiple: true,
        operator: 'OR',
      },
      industry: {
        title: 'Industries',
        fieldName: 'job_industry',
        vid: 'industry',
        multiple: true,
        operator: 'OR',
      },
      occupations: {
        title: 'Occupations',
        fieldName: 'field_job_occupational_field_parents_all',
        vid: 'occupational_fields',
        multiple: true,
        operator: 'OR',
      },
      yearsOfExperience: {
        title: 'Years of experience',
        fieldName: 'field_job_experience',
        vid: 'years_of_experience',
        multiple: true,
        operator: 'OR',
      },
      company: {
        title: 'Company',
        fieldName: 'job_organization_name',
        multiple: true,
        operator: 'OR',
      },
    },
    SEO: {
      CLEAN_FACETS_ORDER: [
        'field_job_occupational_field_parents_all',
        'field_job_employment_type',
        'field_remote_option',
        'job_industry',
        'field_job_experience',
      ],
      CLEAN_FACETS_NUMBER: 2,
      NO_INDEX_EMPTY_PAGE: true,
    },
    JOB_SEARCH_NOINDEX_AND_NO_CANONICAL_FOR_JOBID: false,
    HIDE_GEO_SEARCH: false,
    HIDE_KEYWORD_SEARCH: false,
    GEO_INFO: {
      radius: {
        options: [5, 25, 50, 100, 200],
        defaultValue: 100,
        unit: 'km',
        unitMultiplier: 1,
        hideForLocationType: [
          'country',
          'administrative_area_level_1',
          'administrative_area_level_2',
          'administrative_area_level_3',
        ],
      },
      types: ['(regions)'],
      fixtures: null,
    },
    JOB_ALERT: {
      MODAL: {
        APPLICABLE_JOB_APPLICATION_WORKFLOW: [],
        FREQUENCY_DAYS: 10,
      },
      ignoreFields: ['notify_interval'],
      popup: {
        notifyIntervalValues: null,
      },
    },
    JOB_APPLY_ATTACHMENTS_REQUIRED: {
      AUTHENTICATED: false,
      ANONYMOUS: false,
    },
    JOB_APPLY_LOGGED_IN_USER_SHOW_FIRST_LAST_NAME_FIELDS: false,
    ANALYTICS: {
      SOURCE_ENABLED: true,
    },
    DISABLE_EDIT_EXTERNAL_JOBS: true,
    JOB_CIPHER_JOBS_ENABLED: false,
    JOB_TRACKING_PIXEL_ENABLED: false,
    JOB_TRACKING_PIXEL_WITH_REQUIRED_FROM_QUERY_PARAMS: [],
    JOB_PT_ATTACHMENT_ENABLED: false,
    SEASONAL_JOBS_ENABLED: false,
    SHOW_ONLY_FEATURED_JOBS: false,
    // Like SHOW_ONLY_FEATURED_JOBS, but only jobs whose featured upgrade is for the current frontend.
    SHOW_ONLY_FEATURED_JOBS_BY_UPGRADE_FRONTEND: false,
    SHOW_ONLY_FEATURED_VIDEO_JOBS: false,
    TEASER_SHOW_FEATURED_INDICATORS: true,
    DETAIL_SHOW_FEATURED_INDICATORS: true,
    DETAIL_SHOW_TOP_JOB_INDICATORS: true,
    DETAIL_NOFOLLOW_EXTERNAL_DESCRIPTION_LINKS: false,
    DETAIL_PLAINTEXT_EXTERNAL_DESCRIPTION_LINKS: false,
    FEATURED_JOBS_HIDE_BACKFILL_IMPORTER_JOBS: false,
    ALLOWED_JOB_TYPES: ['job_per_template', 'job_per_link', 'job_per_file'],
    HIDE_JOB_LOCATION: false,
    SHOW_PUBLISHED_DATE: true,
    SHOW_EXPIRATION_DATE: false,
    REMOTE_JOBS_FEATURE_ACTIVE: true,
    UNPUBLISHED_JOB_FADE_HEIGHT_PX: 550,
    AUTOSUGGESTIONS_ENABLED: false,
    AUTOSUGGESTIONS_AUTOFILL_FIELDS: [],
    HIDE_PUBLISH_OPTION_WORKFLOW_STATES: [
      'needs_review',
      'published',
      'archived',
      'scheduled',
    ],
    JOB_SEARCH_SHOW_ORG_BANNER: true,
    SCHEDULED_JOB_FEATURE_ACTIVE: true,
    FLAGGED_FIELDS: [
      {
        REMOTE_JOBS_FEATURE_ACTIVE: {
          form: {
            groupKey: 'job_location',
            fieldName: 'field_remote_option',
          },
          facet: {
            fieldName: 'field_remote_option',
          },
        },
      },
    ],
    SCHEMA_ORG: {
      DIRECT_APPLY: true,
    },
    JOB_APPLICATION_FIELDS: {
      job_application_info: {
        key: 'job_application_info',
        fields: {
          field_job_application_first_name: 'firstName',
          field_job_application_last_name: 'lastName',
          field_job_application_email_addr: 'emailAddress',
          field_job_application_phone: null,
          field_job_application_cover: 'coverLetter',
          field_job_application_attachment: 'attachments',
          field_job_application_qa: 'answers',
        },
      },
    },
    JOB_APPLICATION_FORCE_REGISTRATION: false,
    JOB_APPLICATION_FORCE_REGISTRATION_ALL_JOBS: false,
    JOB_APPLICATION_FORCE_REGISTRATION_DESTINATION:
      allowedForcedRegistrationDestination.Login,
    JOB_APPLICATION_ACTIONS_SHARE_EMAIL_ACTIVE: true,
    JOB_APPLICATION_ACTIONS_EXPORT_ACTIVE: true,
    AI: {
      JOB_DESCRIPTION: {
        enabled: false,
        // ONLY USE THIS WHEN HAVING A DEDICATED CLIENT ACCOUNT!
        dangerous_enabled_anonymous: false,
        temperature: 0.5,
        maxTokens: 1500,
        languages: {
          en: 'English',
          de: 'Deutsch',
          fr: 'Français',
        },
      },
    },
    BOOKMARKS_ENABLED: true,
    JOB_SEARCH_ADS_TEASER_FREQUENCY: 5,
    SELF_SERVICE_CONTACT_REQUEST_CREDITS_POPUP: {
      enabled: false,
      contactCreditCta: {
        link: '/resumes',
      },
      contactCreditCtaSecondary: {
        link: '/my-products',
      },
    },
    SELF_SERVICE_SUCCESS_POST_JOB_DESTINATION: '/job/wizard',
    SELF_SERVICE_SUCCESS_SECONDARY_BUTTON_DESTINATION: '/job-manager',
    FEATURED_JOBS_SETTINGS: {
      RANGE: {
        FIRST: 0,
        LAST: 6,
      },
    },
    VIDEO_JOBS_SETTINGS: {
      RANGE: {
        FIRST: 0,
        LAST: 6,
      },
    },
    // Jobs of the week configuration.
    SHOW_ONLY_TOP_JOBS: true,
    TOP_JOBS_SETTINGS: {
      RANGE: {
        FIRST: 0,
        LAST: 6,
      },
    },
    JOBS_OF_THE_WEEK_HIDE_BACKFILL_IMPORTER_JOBS: false,
    JOB_POSTING_WIZARD_SHOW_DESTINATION: false,
    // Skip if the current frontend default bundle is included in the flatrate.
    JOB_POSTING_WIZARD_SKIP_BUNDLES_CURRENT_INCLUDED: false,
    // Skip only if all bundles are included in the flatrate.
    JOB_POSTING_WIZARD_SKIP_BUNDLES_ALL_INCLUDED: false,
    JOB_POSTING_JOB_BUNDLES_SHOW_FROM_ALL_ORG_FRONTENDS: true,
    SHOW_UPGRADES_IN_DESTINATION_STEP: false,
    DESTINATION_PAGE_CONFIG: {
      SEPARATE_UPGRADES_STEP: false,
      UPGRADES_MORE_INFO: false,
      PRESELECT_ALL_FRONTENDS: false,
    },
    MAP: {
      TOKEN: null,
      CENTER: [-87.6298, 41.8781],
      CENTER_ON_USER_FIRST: false,
      STYLE:
        'mapbox://styles/joaogarin/cjypwnamm051l1crs4piohem9?optimize=true',
      CIRCLE_COLORS: {
        SMALL: '#33bda6',
        MEDIUM: '#FFD700',
        HIGH: '#FF6347',
        POINT: '#33bda6',
        POINT_BORDER: '#7bdbcb',
      },
    },
    SHOW_ORGANIZATION_JOBS_ON_DETAIL_PAGE: false,
    SHOW_ORGANIZATION_PRESENTATION_ON_DETAIL_PAGE: false,
    JOB_SEARCH_TITLE_ABOVE_FILTERS: false,
    JOB_SEARCH_QUERYSTRING_INDEX: false,
    HIDE_JOB_CART: false,
    JOB_SEARCH_SORTING_FILTER_ENABLED: false,
    JOB_SEARCH_AUTO_SELECT_FIRST_JOB: false,
    JOB_DESCRIPTION_FORCE_IFRAME: false,
    JOB_SOLR_BACKFILL: false,
  },
  server: {},
};
